import { FC, useState } from "react";
import Section from "components/kaleido/parts/Section";
import AnchorTarget from "components/official/AnchorTarget";
import Headline from "components/kaleido/long/parts/Headline";
import styled from "styled-components";
import useObserver from "lib/hooks/kaleido/useObserver";
import BreakPc from "components/gonzo/parts/BreakPc";

const Story: FC = () => {
  const [visibleSection, setVisibleSection] = useState<string | null>(null);
  const sectionVisibilityFlags = useObserver(setVisibleSection);
  const isVisible = sectionVisibilityFlags["story"] || visibleSection === "story";
  
  return (
    <StyledSection className={`section ${isVisible ? "visible" : "hidden"}`} id="story">
      <AnchorTarget id="story" />
      <Headline src={"/image/lp/kaleido/story/head.png"} alt="ストーリー" />
      <Content>
        <DescriptionWrapper>
          <Description>
            可憐に美しく、もっと高くはばたきたい！！
            <br />
            <br />
            汗と涙の美少女青春サクセスストーリー！！
            <br />
            「カレイドステージ」。それはサーカスでもない。ミュージカルでもない。
            <br />
            マジックでもない世界的に大人気のエンターテイメントショウ。
            <BreakPc />
            主人公・苗木野そらは16歳の女の子。幼い頃、今は亡き両親と観た思い出の「カレイドステージ」に憧れて、たった1人、オーディションを受けるため義父母の反対を押し切り日本から単身アメリカへやってきた。
            <br />
            オーディションに遅刻しながらも特例として入団を認められはしたが周囲の風当たりは冷たい。
            <br />
            そんな中、そらの持ち前の、決して諦めない根性と天性の＜華＞、
            <BreakPc />
            そして仲間達との友情と確執の中で、ステージの花形＜カレイドスター＞を目指してあらゆる試練を乗り越えていく。
          </Description>
          <Banner src={"/image/lp/kaleido/story/logo.png"} alt="ロゴ画像" />
          <LeftStar src={"/image/lp/kaleido/story/head_left.png"} alt="左星" />
          <RightStar src={"/image/lp/kaleido/story/head_right.png"} alt="右星" />
        </DescriptionWrapper>
      </Content>
    </StyledSection>
  );
};
export default Story;

const StyledSection = styled(Section)`
  transition: opacity 0.5s ease-in-out;
  opacity: 0;
  &.visible {
    opacity: 1;
  }
  &.hidden {
    opacity: 0;
  }
  margin-top: 5vw;
  width: 100%;
  
  @media screen and (max-width: 460px) {
    margin-bottom: 50px;
  }
  @media screen and (min-width: 461px) {
    margin-bottom: 90px;
  }
  @media screen and (min-width: 661px) {
    margin-bottom: 110px;
  }
  @media screen and (min-width: 961px) {
    width: 90vw;
    margin-bottom: 120px;
  }
  @media screen and (min-width: 1111px) {
    width: 1000px;
    margin-bottom: 140px;
  }
  @media screen and (min-width: 1281px) {
    margin-bottom: 160px;
  }
`;
const Content = styled.div`
  @media screen and (max-width: 960px) {
    padding: 0 8vw;
    font-size: 2vw;
  }
  @media screen and (min-width: 961px) {
    font-size: 12px;
  }
  @media screen and (min-width: 1001px) {
    font-size: 13px;
  }
`;
const DescriptionWrapper = styled.div`
  position: relative;
`;
const Description = styled.p`
  line-height: 2em;
  letter-spacing: 0.2em;
  color: black;
  font-size: 1.5em;
  
  @media screen and (max-width: 960px) {
    text-align: left;
    margin-bottom: 10vw;
  }
  @media screen and (min-width: 961px) {
    text-align: center;
    margin: 0 auto 50px;
    max-width: 900px;
  }
  
  & a {
    color: black;
    text-decoration: underline;
  }
`;
const Banner = styled.img`
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  z-index: -1;

  @media screen and (max-width: 960px) {
    top: 12vw;
    width: 70vw;
  }
  @media screen and (min-width: 961px) {
    width: 500px;
  }
  @media screen and (min-width: 1001px) {
    width: 510px;
  }
  @media screen and (min-width: 1481px) {
    width: 520px;
  }
`;
const LeftStar = styled.img`
  position: absolute;
  bottom: 0px;
  left: 0%;
  transform: translateX(-50%);
  z-index: 10;
  top: -180px;


  @media screen and (max-width: 300px) {
    top: -45px;
    left: 4vw;
    width: 75px;
  }
  @media screen and (min-width: 301px) {
    top: -50px;
    left: 4.5vw;
    width: 80px;
  }
  @media screen and (min-width: 351px) {
    top: -55px;
    left: 4.5vw;
    width: 90px;
  }
  @media screen and (min-width: 401px) {
    top: -60px;
    left: 4.5vw;
    width: 100px;
  }
  @media screen and (min-width: 501px) {
    top: -80px;
    left: 4.5vw;
    width: 125px;
  }
  @media screen and (min-width: 601px) {
    top: -95px;
    left: 4vw;
    width: 140px;
  }
  @media screen and (min-width: 701px) {
    top: -110px;
    left: 4.5vw;
    width: 170px;
  }
  @media screen and (min-width: 801px) {
    top: -115px;
    left: 3vw;
    width: 175px;
  }
  @media screen and (min-width: 901px) {
    top: -120px;
    left: 3vw;
    width: 190px;
  }

  @media screen and (min-width: 961px) {
    top: -145px;
    left: 6vw;
    width: 200px;
  }
  @media screen and (min-width: 1001px) {
    top: -155px;
    left: 7vw;
    width: 240px;
  }
  @media screen and (min-width: 1101px) {
    top: -160px;
    left: 7vw;
    width: 260px;
  }
  @media screen and (min-width: 1151px) {
    top: -160px;
    left: 5vw;
    width: 260px;
  }
  @media screen and (min-width: 1201px) {
    top: -170px;
    left: 3vw;
    width: 270px;
  }
  @media screen and (min-width: 1251px) {
    top: -170px;
    left: 1vw;
    width: 270px;
  }
  @media screen and (min-width: 1301px) {
    left: 0vw;
    width: 280px;
  }
  @media screen and (min-width: 1351px) {
    left: -2vw;
    width: 280px;
  }
  @media screen and (min-width: 1401px) {
    left: -3vw;
    width: 290px;
  }
  @media screen and (min-width: 1481px) {
    left: -5vw;
    width: 300px;
  }
  @media screen and (min-width: 1501px) {
    left: -6vw;
    width: 300px;
  }
  @media screen and (min-width: 1551px) {
    left: -7vw;
    width: 300px;
  }
  @media screen and (min-width: 1601px) {
    left: -8vw;
    width: 300px;
  }
  @media screen and (min-width: 1651px) {
    left: -9vw;
    width: 300px;
  }
  @media screen and (min-width: 1701px) {
    left: -11vw;
    width: 300px;
  }
  @media screen and (min-width: 1751px) {
    left: -11.5vw;
    width: 300px;
  }
  @media screen and (min-width: 1801px) {
    left: -13vw;
    width: 300px;
  }
  @media screen and (min-width: 1901px) {
    left: -14.5vw;
    width: 300px;
  }
  @media screen and (min-width: 2001px) {
    left: -17vw;
    width: 300px;
  }
  @media screen and (min-width: 2101px) {
    left: -18vw;
    width: 300px;
  }
  @media screen and (min-width: 2201px) {
    left: -19vw;
    width: 320px;
  }
  @media screen and (min-width: 2401px) {
    left: -22vw;
    width: 320px;
  }
  @media screen and (min-width: 2701px) {
    left: -25vw;
    width: 320px;
  }
  @media screen and (min-width: 3001px) {
    left: -800px;
    width: 320px;
  }
`;
const RightStar = styled.img`
  position: absolute;
  bottom: 0px;
  right: 0%;
  transform: translateX(-50%);
  z-index: -1;
  top: -180px;


  @media screen and (max-width: 300px) {
    top: -45px;
    left: 80vw;
    width: 75px;
  }
  @media screen and (min-width: 301px) {
    top: -50px;
    left: 80vw;
    width: 80px;
  }
  @media screen and (min-width: 351px) {
    top: -55px;
    left: 80vw;
    width: 90px;
  }
  @media screen and (min-width: 401px) {
    top: -60px;
    left: 80vw;
    width: 100px;
  }
  @media screen and (min-width: 501px) {
    top: -80px;
    left: 80vw;
    width: 125px;
  }
  @media screen and (min-width: 601px) {
    top: -95px;
    left: 80vw;
    width: 140px;
  }
  @media screen and (min-width: 701px) {
    top: -110px;
    left: 80vw;
    width: 170px;
  }
  @media screen and (min-width: 801px) {
    top: -115px;
    left: 81vw;
    width: 175px;
  }
  @media screen and (min-width: 901px) {
    top: -120px;
    left: 82vw;
    width: 190px;
  }

  @media screen and (min-width: 961px) {
    top: -145px;
    left: 84vw;
    width: 200px;
  }
  @media screen and (min-width: 1001px) {
    top: -155px;
    left: 83vw;
    width: 240px;
  }
  @media screen and (min-width: 1101px) {
    top: -160px;
    left: 82vw;
    width: 260px;
  }
  @media screen and (min-width: 1151px) {
    top: -160px;
    left: 81vw;
    width: 260px;
  }
  @media screen and (min-width: 1201px) {
    top: -170px;
    left: 79.5vw;
    width: 270px;
  }
  @media screen and (min-width: 1251px) {
    top: -170px;
    left: 78vw;
    width: 270px;
  }
  @media screen and (min-width: 1301px) {
    left: 77vw;
    width: 280px;
  }
  @media screen and (min-width: 1351px) {
    left: 75vw;
    width: 280px;
  }
  @media screen and (min-width: 1401px) {
    left: 74vw;
    width: 290px;
  }
  @media screen and (min-width: 1481px) {
    left: 72vw;
    width: 300px;
  }
  @media screen and (min-width: 1501px) {
    left: 71.8vw;
    width: 300px;
  }
  @media screen and (min-width: 1551px) {
    left: 71vw;
    width: 300px;
  }
  @media screen and (min-width: 1601px) {
    left: 70vw;
    width: 300px;
  }
  @media screen and (min-width: 1651px) {
    left: 69vw;
    width: 300px;
  }
  @media screen and (min-width: 1701px) {
    left: 68.5vw;
    width: 300px;
  }
  @media screen and (min-width: 1751px) {
    left: 68.1vw;
    width: 300px;
  }
  @media screen and (min-width: 1801px) {
    left: 68vw;
    width: 300px;
  }
  @media screen and (min-width: 1901px) {
    left: 67.2vw;
    width: 300px;
  }
  @media screen and (min-width: 2001px) {
    left: 66vw;
    width: 300px;
  }
  @media screen and (min-width: 2101px) {
    left: 65vw;
    width: 300px;
  }
  @media screen and (min-width: 2201px) {
    left: 64vw;
    width: 320px;
  }
  @media screen and (min-width: 2401px) {
    left: 63vw;
    width: 320px;
  }
  @media screen and (min-width: 2701px) {
    left: 61vw;
    width: 320px;
  }
  @media screen and (min-width: 3001px) {
    left: 1800px;
    width: 320px;
  }
`;